import { Button, Modal } from "../../../components";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const StartNewApplicationConfirmModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Start a new application?"
      subtitle="You already have an ongoing application in progress. Starting a new one will discard the current application."
      variant="expanded"
    >
      <div className="cx-flex cx-flex-col sm:cx-flex-row cx-gap-3 sm:cx-gap-x-4">
        <div className="cx-w-full sm:cx-w-1/2">
          <Button label="Cancel" outlined fullWidth onClick={onClose} />
        </div>
        <div className="cx-w-full sm:cx-w-1/2">
          <Button label="Start new application" fullWidth onClick={onConfirm} />
        </div>
      </div>
    </Modal>
  );
};

export default StartNewApplicationConfirmModal;
